!((document, Drupal) => {
  'use strict';
  Drupal.behaviors.heroVideo = {
    attach: function() {
      /**
       * Handles hero videos.
       *
       * @returns {void}
       */
      function videoControl() {
        // Does the browser actually support the video element?
        const supportsVideo = Boolean(
          document.createElement('video').canPlayType
        );
        let videoPlaying = true;
        let videoHidden = false;
        let reducedMotion = false;

        if (supportsVideo) {
          // Obtain handles to main elements
          const video = document.getElementById('hero-video');

          const videoControls = document.getElementById('video-controls');
          if (video && videoControls) {
            // Hide the default controls
            video.controls = false;

            // Display the user defined video controls
            videoControls.setAttribute('data-state', 'visible');

            // Obtain handles to buttons and other elements
            const playpause = document.getElementById('playpause');

            // Changes the button state
            const changeButtonState = function(type) {
              // Play/Pause button

              if (type === 'playpause') {
                if (video.paused || video.ended) {
                  playpause.setAttribute('data-state', 'play');
                }
                else {
                  playpause.setAttribute('data-state', 'pause');
                }
              }
            };
            // the button doesn't load with a state,
            // so this will set it on load
            changeButtonState('playpause');
            //detect prefers reduced motion and don't let video play
            // Grab the prefers reduced media query.
            const reducedMotionQuery = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            );

            // Check if the media query matches or is not available.
            if (!reducedMotionQuery || reducedMotionQuery.matches) {
              reducedMotion = true;
            }
            else {
              reducedMotion = false;
            }

            // Ads an event listener to check for changes in the media query's value.
            reducedMotionQuery.addEventListener('change', () => {
              if (reducedMotionQuery.matches) {
                // reduced motion
                if (!video.paused) {
                  video.pause();
                  changeButtonState('playpause');
                }
              }
            });

            const pauseHiddenVideo = () => {
              if (window.getComputedStyle(video).display === 'none') {
                if (!video.paused && !videoHidden) {
                  video.pause();
                  changeButtonState('playpause');
                  videoPlaying = true;
                }
                else if (video.paused && !videoHidden) {
                  videoPlaying = false;
                }
                videoHidden = true;
                if (video.preload === 'auto') {
                  video.preload = 'none';
                }
              }
              else {
                if (videoHidden && videoPlaying) {
                  if (video.paused) {
                    video.play();
                    changeButtonState('playpause');
                  }
                  videoPlaying = true;
                }
                videoHidden = false;
                if (video.preload === 'none') {
                  video.preload = 'auto';
                }
                if (!reducedMotion) {
                  video.autoplay = true;
                }
                else {
                  video.autoplay = false;
                }
              }
            };

            window.onresize = pauseHiddenVideo;
            pauseHiddenVideo();
            // Add event listeners for video specific events
            video.addEventListener(
              'play',
              function() {
                changeButtonState('playpause');
              },
              false
            );
            video.addEventListener(
              'pause',
              function() {
                changeButtonState('playpause');
              },
              false
            );

            // Add events for all buttons
            playpause.addEventListener('click', function() {
              if (video.paused || video.ended) {
                video.play();
              }
              else {
                video.pause();
              }
            });
          }
        }
      }
      videoControl();
    }
  };
})(document, Drupal);
